/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import receiveConnections from './receive-connections';
import * as actions from 'state/action-types';

export default (connectionId = null, connection) => (dispatch) => {

    return cecSdk
        .connection(connectionId)
        .migrate(connection)
        .then((connection) => {
            dispatch(receiveConnections([connection]));
            dispatch({ type: actions.IMPORT_CONNECTION_SUCCESS, payload: { connection } });
        });
};